import { Button, Card, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import useScript from "../hooks/useUrlScript";

type Props = {};

const SelfFilingSuccess = (props: Props) => {
  const navigate = useNavigate();
  const scriptUrlGoogle = "https://www.googletagmanager.com/gtag/js?id=AW-16619945585";
  const googleScript = ` window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-16619945585');`;
  const fbScriptUrl = useScript(scriptUrlGoogle, googleScript);
  // useScript(fbScriptUrl, fbScriptPixel);
  // useInlineScript(`window.lintrk('track', { conversion_id: 16880364 })`);
  return (
    <div className="success-page-wrap">
      <Container className="w-800">
        <Card bg="white" className="success-card">
          <Card.Body>
            <h1 className="fw-bold text-center mb-1">Purchase Successful</h1>
            <div className="btn-wrap mt-5">
              <Button
                variant="primary"
                type="submit"
                size="lg"
                className="w-100 shadow"
                onClick={() => navigate("/", { replace: true })}
              >
                Continue
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default SelfFilingSuccess;
